<button *ngIf="sort; else content" (click)="changeSort(!isAscending)" [ngClass]="{ unsorted: !isActive }" type="button">
    <span class="header-text">
        {{ text }}
        <div *ngIf="secondaryText" class="secondary">{{ secondaryText }}</div>
    </span>
    <span class="material-symbols-rounded sort-icon" aria-label="hidden" *ngIf="isAscending && isActive; else down">
        arrow_upward_alt
    </span>
    <ng-template #down>
        <span class="material-symbols-rounded sort-icon" aria-label="hidden"> arrow_downward_alt </span>
    </ng-template>
</button>

<ng-template #content>
    <app-checkbox #chb *ngIf="checkbox" [ngModel]="isChecked" (ngModelChange)="changeChecked($event)" />
    {{ text }}
</ng-template>
